import PropTypes from "prop-types";
import RadioButton from "@shared/v2/RadioButton";
import TextComboInput from "@shared/v2/TextComboInput";

const ExpenseInput = ({ label, value, name, onValueUpdate, onRadioUpdate, isPercentage, disableFlip }) => (
  <div className="tw-flex tw-flex-col tw-gap-[8px]">
    <TextComboInput
      label={label}
      leading={isPercentage ? "" : "$"}
      trailing={isPercentage ? "%" : ""}
      value={value}
      onChange={onValueUpdate}
      size={1}
    />

    {!disableFlip && (
      <div className="tw-flex tw-gap-[16px]">
        <RadioButton
          label="Percent"
          value="percent"
          checked={isPercentage}
          name={name}
          onChange={() => onRadioUpdate(true)}
        />
        <RadioButton
          label="Flat"
          value="flat"
          checked={!isPercentage}
          name={name}
          onChange={() => onRadioUpdate(false)}
        />
      </div>
    )}
  </div>
);

ExpenseInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isPercentage: PropTypes.bool,
  disableFlip: PropTypes.bool,
  onValueUpdate: PropTypes.func.isRequired,
  onRadioUpdate: PropTypes.func.isRequired,
};

ExpenseInput.defaultProps = {
  isPercentage: false,
  disableFlip: false,
};

export default ExpenseInput;
